import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
export const IconFioriAction = (props) =>
  _jsxs('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: [
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M17.617 2.076a1 1 0 0 1 1.09.217l3 3a1 1 0 0 1 0 1.414l-3 3A1 1 0 0 1 17 9V3a1 1 0 0 1 .617-.924Z',
        fill: 'currentColor',
      }),
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M17 7a4 4 0 0 0-4 4v5a1 1 0 1 1-2 0v-5a6 6 0 0 1 6-6v2Z',
        fill: 'currentColor',
      }),
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M6 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12.004a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h4.004a1 1 0 0 1 0 2H6Z',
        fill: 'currentColor',
      }),
    ],
  });
IconFioriAction.displayName = 'IconFioriAction';
